module.exports = __webpack_public_path__ + "static/media/spoken.6e2a3431.png";